import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { Row } from 'styled-bootstrap-grid';
import { ButtonProps } from '@ch/common/components/button/types';
import { Button } from '@ch/common/components/button';
import { masterLang, RoutePath } from '../const';
import { useQuiz } from '../quiz/hooks/use-quiz';
import { useLang } from '../use-lang';
import { useData } from '../use-data';

export const HomeNavigation: FC<Omit<ButtonProps, 'onClick'> & { isLightButton?: boolean }> = ({
  isLightButton = false,
  ...props
}) => {
  const navigate = useNavigate();
  const { eventQuestion } = useQuiz();
  const { lang } = useLang();
  const {
    data: {
      theme: { btnLight, btnDark },
    },
  } = useData();

  return (
    <Row>
      {eventQuestion.options.map(({ option, identifier }) => (
        <Button
          key={identifier}
          onClick={() => navigate(`${RoutePath.FORM}/${identifier}${lang !== masterLang ? `?lang=${lang}` : ''}`)}
          {...props}
          $defaultColor={isLightButton ? { ...btnLight } : { ...btnDark }}
        >
          {option}
        </Button>
      ))}
    </Row>
  );
};
